import { render, staticRenderFns } from "./Votantes.vue?vue&type=template&id=69b48298"
import script from "./Votantes.vue?vue&type=script&lang=js"
export * from "./Votantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports